import React, {useState, useEffect} from "react";
import {
    Button,
    Modal,
    Typography,
    Grid,
    InputLabel,
    TextField,
    FormControlLabel,
    MenuItem,
    Card,
    CardContent,
    Select,
    CardActions
} from "@material-ui/core";
import {Switch, withStyles} from '@material-ui/core';
import axios from "../../api";
import '../../App.css';
import Swal from "sweetalert2";

function EditarConsultorios({id, title, apiUrl, fetchTableData}) {
    const [open, setOpen] = useState(false);
    const [data, setData] = useState(null);
    const [formValues, setFormValues] = useState(null);
    const [selectedMedico, setSelectedMedico] = useState('');
    const [medicoResponsavelConsultorio, setMedicoResponsavelConsultorio] = useState([]);


    //método para realizar a alteração do witch button
    const handleSwitch = (e) => {
        const {name, value, type, checked} = e.target;
        const newValue = type === 'checkbox' ? checked : value;

        setFormValues({
            ...formValues, [name]: newValue,
        });
    };

    const SquareSwitch = withStyles({
        switchBase: {
            borderRadius: 4,
            '&$checked': {
                color: '#fff',
                '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                },
            },
            '&$checked + $track': {
                backgroundColor: '#00c853',
            },
        },
        checked: {},
        track: {
            backgroundColor: 'rgba(0, 0, 0, 0.38)',
        },
    })(Switch);

    //pega o nomes dos medicos responsaveis que estao no consultorio
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('/users', {timeout: 5000});
                setMedicoResponsavelConsultorio(response.data.data);
            } catch (e) {
                console.log(e);
            }
        };
        fetchData();
    }, []);

    // método responsavel por abrir o formulario com os dados rpreciamente carregados
    const handleOpen = () => {
        setOpen(true);
        axios.get(apiUrl + id).then((response) => {
            setData(response.data.data);
            setFormValues(response.data.data);
        });
    };

    //método responsavel por fechar o modal
    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (event) => {
        const {name, value} = event.target;
        setFormValues((prevValues) => ({
            ...prevValues, [name]: value,
        }));
    };


    function validateFields() {
        if (formValues.consultorio === '') {
            return false;
        }

        if (formValues.ativo === '') {
            return false;
        }

        if (formValues.usuario_id === '') {
            return false;
        }

        return true;
    }


    //método que realiza o envio de dados para a api
    const handleSubmit = (e) => {
        e.preventDefault();

        //verifica se as validações então dentro do solicitado
        if (!validateFields()) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Preencha todos os campos obrigatórios.',
                footer: 'Por favor, verifique os campos e tente novamente.'
            });
            return;
        }

        //defini as contates de informações a serem salvas no formulario
        const {Funcionario_responsavel, ativo, consultorio, flag, id} = formValues;
        //pega o id do medico que vai ser inserido dentro do relacionamento na api
        const medicoId = selectedMedico ? selectedMedico.id : '';
        //chamam o método put para definir e finalizar a alteração de dados
        axios.put(`/consultorios/${id}`, {
            Funcionario_responsavel: Funcionario_responsavel,
            ativo: ativo,
            consultorio: consultorio,
            flag: flag,
            usuario_id: medicoId,

        }, {timeout: 5000})

            .then((response) => {
                console.log();
                Swal.fire({
                    icon: 'success',
                    title: 'Muito bem !',
                    text: response.data.message,
                });
                setOpen(false);
            })
        fetchTableData()
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Ocorreu um erro ao salvar os dados.',
                    footer: 'Por favor, tente novamente mais tarde.'
                });
            });

    };
    return (
        <div>
            <Button id="edit" variant="contained" size="small" size="small" onClick={handleOpen}>
                <i className="fas fa-pencil"></i> Editar
            </Button>
            <Modal open={open} onClose={handleClose}>
                <div
                    style={{
                        position: "absolute",
                        top: "40%",
                        left: "54%",
                        transform: "translate(-50%, -50%)",
                        width: "70%",
                        backgroundColor: "white",

                    }}
                >
                    <br/>
                    {formValues && (<form onSubmit={handleSubmit}>

                        <Card>
                            <CardContent>
                                <Typography variant="h5">{title}</Typography>
                                <Grid item xs={12}>

                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <InputLabel style={{padding: '0.5rem'}}>Consultório Descrição</InputLabel>
                                            <TextField
                                                fullWidth
                                                id="outlined-required"
                                                variant="outlined"
                                                size="small"
                                                name="consultorio"
                                                value={formValues.consultorio}
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <InputLabel style={{padding: '0.5rem'}}>Médico responsável</InputLabel>
                                            <Select
                                                fullWidth
                                                id="outlined-required"
                                                value={selectedMedico ? selectedMedico.id : ''}
                                                onChange={(e) => setSelectedMedico(medicoResponsavelConsultorio.find(medico => medico.id === e.target.value))}
                                                variant="outlined"
                                                size="small"
                                                style={{height: '42px'}} // adicione esta linha
                                                displayEmpty
                                            >
                                                <MenuItem value="">Selecione</MenuItem>
                                                {medicoResponsavelConsultorio.map(medico => (
                                                    <MenuItem key={medico.id} value={medico.id}>
                                                        {medico.name}
                                                    </MenuItem>))}
                                            </Select>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControlLabel
                                                control={<SquareSwitch
                                                    checked={formValues.ativo}
                                                    onChange={handleSwitch}
                                                    name="ativo"
                                                    inputProps={{'aria-label': 'controlled'}}
                                                />}
                                                label="Ativo"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        {/*//fotter do modal*/}
                        <CardActions>
                            <Button variant="contained" id="success" type="submit">
                                <i className="fa-solid fa-plus"></i> Salvar
                            </Button>

                            <Button variant="contained" color="secondary" type="submit" onClick={handleClose}><i
                                className="fas fa-remove"></i>Cancelar</Button>
                        </CardActions>
                    </form>)}
                </div>
            </Modal>
        </div>
    );
}

export default EditarConsultorios;
